import { Component, OnInit, inject, input, output, signal } from '@angular/core';
import { DebugService } from '../../../service/debug.service';
import { UserLoginService } from '../../../service/user-login.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  standalone: false,
})
export class AppHeaderComponent implements OnInit {
  public debug = inject(DebugService);

  showUserInfo = input<boolean>(true);
  logoutRoute = input<string>('/logout');
  // I don't know why this has to be different from logoutRoute,
  // but don't wanna break anything
  mobileLogoutRoute = input<string>('/home/logout');

  isLoggedIn = signal<boolean>(false);

  user = signal<string>('');

  public showHamburger = input<boolean>(true);
  public hamburgerClicked = output<void>();

  private userService = inject(UserLoginService);

  ngOnInit(): void {
    if (this.showUserInfo()) {
      this.userService.auth.user$.subscribe((claims) => {
        if (!claims) {
          return;
        }
        this.isLoggedIn.set(true);
        this.user.set(`${claims.nickname} (${claims.email})`);
      });
    }
  }
}
